import { patch, post, read } from '@/utils/request'
import type { DetailWithLogs, ListData } from 'bv-typings'

export type MccMaintenanceInfo = {
  id: string
  mcc: string // Mcc
  name: string // 名称
  status: number // 状态
  createDate: string // 创建时间
  updateDate: string // 修改时间

  billingId: string
}

const baseUrl = 'gg_account_opening/mcc'

const getMccList = async (params?: any, signal?: any) => {
  return read<ListData<MccMaintenanceInfo>>(baseUrl, params, undefined, undefined, { signal })
}

type MccMaintenanceDetail = DetailWithLogs<CreateMccParams>

const getMccDetail = async (id: string) => {
  return read<MccMaintenanceDetail>(baseUrl, undefined, '获取详情失败', id)
}

type CreateMccParams = {
  mcc: string
  name: string
  status: number
  isBilling: number
}

async function createMcc (params: CreateMccParams) {
  return post(baseUrl, params, '新增Mcc失败')
}

type EditMccParams = {
  mccName: string
  billingName: string
  status: number
}

async function editMcc (params: Partial<EditMccParams>, id?: string) {
  return patch(baseUrl, params, '编辑Mcc失败', id)
}

export {
  getMccList,
  getMccDetail,
  createMcc,
  editMcc,
}
